export const setMeInitialize = () =>
	({
		type: 'SET_ME_INITIALIZE'
	});
export const setMe = ({ peerId }) =>
	({
		type: 'SET_ME',
		payload: { peerId }
	});

export const setMeUserId = ({ userId }) =>
	({
		type: 'SET_ME_USER_ID',
		payload: { userId }
	});

export const setBrowser = (browser) =>
	({
		type: 'SET_BROWSER',
		payload: { browser }
	});

export const setMeReaction = (reaction) =>
	({
		type: 'SET_ME_REACTION',
		payload: { reaction }
	});

export const setMeEmoji = (emoji) =>
	({
		type: 'SET_ME_EMOJI',
		payload: { emoji }
	});

export const addRole = (roleId) =>
	({
		type: 'ADD_ROLE',
		payload: { roleId }
	});

export const clearRole = () =>
	({
		type: 'CLEAR_ROLE'
	});

export const removeRole = (roleId) =>
	({
		type: 'REMOVE_ROLE',
		payload: { roleId }
	});

export const setPicture = (picture) =>
	({
		type: 'SET_PICTURE',
		payload: { picture }
	});

export const setMediaCapabilities = ({
	canSendMic,
	canSendWebcam,
	canShareScreen,
	canShareFiles
}) =>
	({
		type: 'SET_MEDIA_CAPABILITIES',
		payload: { canSendMic, canSendWebcam, canShareScreen, canShareFiles }
	});

export const setAudioInputDevices = (devices) =>
	({
		type: 'SET_AUDIO_INPUT_DEVICES',
		payload: { devices }
	});

export const setAudioOutputDevices = (devices) =>
	({
		type: 'SET_AUDIO_OUTPUT_DEVICES',
		payload: { devices }
	});

export const setWebcamDevices = (devices) =>
	({
		type: 'SET_WEBCAM_DEVICES',
		payload: { devices }
	});

export const setAudioInProgress = (flag) =>
	({
		type: 'SET_AUDIO_IN_PROGRESS',
		payload: { flag }
	});

export const setAudioOutputInProgress = (flag) =>
	({
		type: 'SET_AUDIO_OUTPUT_IN_PROGRESS',
		payload: { flag }
	});

export const setWebcamInProgress = (flag) =>
	({
		type: 'SET_WEBCAM_IN_PROGRESS',
		payload: { flag }
	});

export const setScreenShareInProgress = (flag) =>
	({
		type: 'SET_SCREEN_SHARE_IN_PROGRESS',
		payload: { flag }
	});

export const setDisplayNameInProgress = (flag) =>
	({
		type: 'SET_DISPLAY_NAME_IN_PROGRESS',
		payload: { flag }
	});

export const setIsSpeaking = (flag) =>
	({
		type: 'SET_IS_SPEAKING',
		payload: { flag }
	});

export const setAutoMuted = (flag) =>
	({
		type: 'SET_AUTO_MUTED',
		payload: { flag }
	});